import React from "react";

interface ChapterSelectionIconProps {
    className?: string;
    color?: string;
    size?: "sm" | "md" | "lg" | "xl";
}

export const ChapterSelectionIcon = ({
                                         className = "",
                                         color = "currentColor",
                                         size = "lg",
                                     }: ChapterSelectionIconProps) => {
    const sizeClasses = {
        sm: "w-4 h-4",   // ~16x16px
        md: "w-6 h-6",   // ~24x24px
        lg: "w-8 h-8",   // ~32x32px
        xl: "w-10 h-10", // ~40x40px
    };

    return (
        <div className="icon chapter-selection-icon">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                className={`${sizeClasses[size]} ${className}`}
                aria-hidden="true"
            >
                {/* Lines */}
                <path d="M7.84,17.90h13.56" strokeWidth={1.5} />
                <path d="M7.84,12h13.56" strokeWidth={1.5} />
                <path d="M7.84,6.10h13.56" strokeWidth={1.5} />

                {/* Dots */}
                <path d="M2.62,17.90h-.01" strokeWidth={2} />
                <path d="M2.62,12h-.01" strokeWidth={2} />
                <path d="M2.62,6.10h-.01" strokeWidth={2} />
            </svg>
        </div>
    );
};

export default ChapterSelectionIcon;